import $ from 'jquery';
import React from 'react';
import { isMobile } from 'react-device-detect';

import { componentForArticleType, correctFotoramaArticleHeight } from '../../articleHelper';
import '../../fotorama/fotorama';

function slidesReadyContentsCount($fotorama) {
  let counter = 0;

  $fotorama.find('article.content').each(function checkContent() {
    if ($(this).text() !== '') {
      counter++;
    }
  });

  return counter;
}

// check complete mount of images
//
// return true, if every content of every image did mount
function imagesDidMount($section) {
  const $images = $section.find('img');

  // return true, if there are no images to check
  if (!$images.length) {
    return true;
  }

  return !!$images.each(function checkContent() {
    $(this).length;
  }).length;
}

// check complete mount of forms
//
// return true, if every content of every form did mount
function formsDidMount($section) {
  const $forms = $section.find('.form');

  // return true, if there are no forms to check
  if (!$forms.length) {
    return true;
  }

  return !!$forms.find('[type="submit"]').each(function checkContent() {
    $(this).val() !== '';
  }).length;
}

// check complete mount of multiple columns
//
// return true, if every content of every column did mount
function multipleColumnsDidMount($section) {
  const $multipleColumns = $section.find('.multiple-column-articles');

  // return true, if there are no forms to check
  if (!$multipleColumns.length) {
    return true;
  }

  // mark a column as mounted if their text content or an image has rendered
  return !!$multipleColumns.find('article').each(function checkContent() {
    $(this).text() !== '' || $(this).find('img').length;
  }).length;
}

// retrieve the value for a given 'slide'-param if an anchor hash for a section is given
//
// @return [Number] index position of slide
function startIndex($section) {
  if (window.location.hash) {
    if (window.location.search && $section.attr('id') === window.location.hash.substring(1)) {
      // inspired by https://css-tricks.com/snippets/javascript/get-url-variables/
      const query = window.location.search.substring(1);
      const params = query.split('&');

      for (let i = 0; i < params.length; i++) {
        const pair = params[i].split('=');

        if (pair[0] === 'slide' && Number(pair[1])) {
          // decrease given value by one because index starts at 0
          // Example: 1 (value) will result in 0 (index)
          return Number(pair[1]) - 1;
        }
      }
    }
  }

  return 0;
}

class HorizontalArticles extends React.Component {
  constructor() {
    super();

    this.state = {
      horizontalArticles: []
    };
  }

  componentDidMount() {
    this.ajaxHorizontalArticles();
  }

  waitForFotoramaAndInit() {
    const { articleId, withParentArticle } = this.props;
    const $section = $(`section[data-article-id="${articleId}"]:not(.map-section)`);
    const $fotorama = $section.find('.fotorama');
    const slidesCount = $fotorama.find('> div').length;
    const horizontalsDidMount = slidesCount && slidesCount === slidesReadyContentsCount($fotorama);

    if (slidesCount > 1) {
      if (
        horizontalsDidMount &&
        imagesDidMount(withParentArticle ? $section : $fotorama) &&
        formsDidMount(withParentArticle ? $section : $fotorama) &&
        multipleColumnsDidMount(withParentArticle ? $section : $fotorama)
      ) {
        this.initFotorama($section, $fotorama);
      } else {
        // recursively call this.waitForFotoramaAndInit() until fotorama can be initialized
        setTimeout(() => {
          this.waitForFotoramaAndInit();
        }, 300);
      }
    }
  }

  initFotorama($section, $fotorama) {
    const { withParentArticle } = this.props;
    const isSmallScreen = document.body.clientWidth < 800;

    $fotorama
      .on('fotorama:ready', () => {
        if (!isMobile) {
          // make text markable with mouse on desktops when fotorama has finished initializing
          // text markable on desktop, but not mobile because of swipe for slides
          $section.find('article.content').addClass('fotorama__select');
        }

        // adjust position of the stage for horizontal articles area on single articles
        !withParentArticle && $fotorama.find('.fotorama__stage__shaft').addClass('position-left');

        // add class to horizontal articles when fotorama has finished initializing
        // because these cannot be different in height to prevent strange layout jumps
        $fotorama
          .find('.fotorama__html > div')
          .addClass(withParentArticle ? 'fullscreen' : 'additional-media');

        // adjust sizes when fotorama has finished initializing
        correctFotoramaArticleHeight(withParentArticle ? $section : $fotorama);
      })
      .on('fotorama:showend', () => {
        // add class to horizontal articles every time fotorama has finished sliding one slide
        // because these cannot be different in height to prevent strange layout jumps
        $fotorama
          .find('.fotorama__html > div')
          .addClass(withParentArticle ? 'fullscreen' : 'additional-media');

        // adjust sizes every time fotorama has finished sliding one slide
        correctFotoramaArticleHeight(withParentArticle ? $section : $fotorama);
      })
      .fotorama({
        height: '100%',
        width: '100%',
        minwidth: 320,
        glimpse: withParentArticle ? 0 : isSmallScreen ? 0 : 200,
        margin: withParentArticle ? 0 : 50,
        arrows: 'always',
        click: false,
        transitionduration: 500,
        swipe: isMobile,
        trackpad: !isMobile,
        startindex: startIndex($section)
      });
  }

  ajaxHorizontalArticles() {
    const { articleId, articleType, withParentArticle } = this.props;

    $.ajax({
      url: `/api/v3/articles/${articleId}/index.json`,
      method: 'GET',
      success: (data) => {
        if (data !== undefined && data !== null) {
          const initialArticles = withParentArticle
            ? [componentForArticleType(articleId, articleType)]
            : [];

          const horizontalArticles = data.articles.reduce((accumulator, slideArticle) => {
            accumulator.push(componentForArticleType(slideArticle[0], slideArticle[1]));
            return accumulator;
          }, initialArticles);

          this.setState({ horizontalArticles }, this.waitForFotoramaAndInit);
        }
      },
      error: (xhr, status, err) => console.error(articleId, status, err.toString())
    });
  }

  render() {
    return <div className="fotorama">{this.state.horizontalArticles}</div>;
  }
}

HorizontalArticles.propTypes = {
  articleId: React.PropTypes.number,
  articleType: React.PropTypes.string,
  withParentArticle: React.PropTypes.bool
};

HorizontalArticles.defaultProps = {
  withParentArticle: true
};

export default HorizontalArticles;



// WEBPACK FOOTER //
// ./components/articles/horizontalArticles.js